// A API nova usa nomes de campo em ingles e devolve listagem paginada no formato
// { totalRows, totalPages, data }. O site continua em portugues e espera array puro
// nas listagens: a traducao entre os dois mundos acontece aqui, para que os models
// e os templates nao mudem.

export interface FieldMap {
    [portugues: string]: string;
}

/** Converte um objeto do site (pt) para o corpo que a API espera (en). */
export function paraApi(obj: any, map: FieldMap): any {

    const out: any = {};

    if (!obj) {
        return out;
    }

    if (obj.id) {
        out.id = obj.id;
    }

    Object.keys(map).forEach(pt => {
        if (obj[pt] !== undefined) {
            out[map[pt]] = obj[pt];
        }
    });

    return out;
}

/** Converte um registro devolvido pela API (en) para o formato do site (pt). */
export function daApi(obj: any, map: FieldMap): any {

    if (!obj) {
        return obj;
    }

    const out: any = { id: obj.id };

    Object.keys(map).forEach(pt => {
        out[pt] = obj[map[pt]];
    });

    return out;
}

/** Desembrulha { totalRows, totalPages, data } devolvendo so o array traduzido. */
export function listaDaApi(res: any, map: FieldMap): any[] {
    const brutos = (res && res.data) ? res.data : [];
    return brutos.map(item => daApi(item, map));
}

/**
 * Query string de listagem publica. O site chama com -99 quando quer tudo, e usava
 * tag='%' como curinga; nos dois casos o parametro simplesmente nao e enviado.
 */
export function parametrosLista(
    numeroPagina?: number,
    registroPorPagina?: number,
    ordem?: { coluna: string, direcao: string },
    tag?: string,
    idIgnorar?: string
): string {

    const partes: string[] = ['situation=A'];

    if (numeroPagina > 0 && registroPorPagina > 0) {
        partes.push(`page=${numeroPagina}`);
        partes.push(`count=${registroPorPagina}`);
    }

    if (ordem) {
        partes.push(`orderColumn=${ordem.coluna}`);
        partes.push(`orderDirection=${ordem.direcao}`);
    }

    if (tag && tag !== '%') {
        partes.push(`tag=${encodeURIComponent(tag)}`);
    }

    if (idIgnorar) {
        partes.push(`idIgnore=${idIgnorar}`);
    }

    return '?' + partes.join('&');
}

// ---------------------------------------------------------------------------
// Mapas de campo por entidade (chave = site, valor = API)
// ---------------------------------------------------------------------------

export const MAP_BANNER: FieldMap = {
    titulo: 'title',
    descricao: 'description',
    link: 'link',
    imagem: 'image'
};

export const MAP_BENEFICIO: FieldMap = {
    icone: 'icon',
    nome: 'name',
    ordem: 'order'
};

export const MAP_CURSO: FieldMap = {
    nome: 'name',
    descricaoSimples: 'simpleDescription',
    descricao: 'description',
    situacao: 'situation',
    slug: 'slug',
    tag: 'tag',
    data: 'date',
    valor: 'price',
    valorPromocao: 'promotionalPrice',
    imagemPequena: 'smallImage',
    imagemGrande: 'largeImage'
};

export const MAP_DEPOIMENTO: FieldMap = {
    foto: 'photo',
    nome: 'name',
    descritivo: 'descriptive',
    depoimento: 'testimonial',
    data: 'date'
};

export const MAP_FATO: FieldMap = {
    imagem: 'image',
    fato1: 'fact1', valorFato1: 'valueFact1',
    fato2: 'fact2', valorFato2: 'valueFact2',
    fato3: 'fact3', valorFato3: 'valueFact3',
    fato4: 'fact4', valorFato4: 'valueFact4'
};

export const MAP_NOTICIA: FieldMap = {
    titulo: 'title',
    descricaoSimples: 'simpleDescription',
    descricao: 'description',
    data: 'date',
    tempoLeitura: 'readingTime',
    situacao: 'situation',
    slug: 'slug',
    tag: 'tag',
    imagemPequena: 'smallImage',
    imagemGrande: 'largeImage'
};

export const MAP_SOBRE: FieldMap = {
    descricao: 'description',
    imagem: 'image'
};

export const MAP_CADASTRO_GERAL: FieldMap = {
    titulo: 'title',
    descricao: 'description',
    palavrasChave: 'keywords',
    cor: 'color'
};

export const MAP_CONTATO_GERAL: FieldMap = {
    telefoneSecretaria: 'phoneSecretary',
    telefoneComercial: 'phoneCommercial',
    telefoneFixo: 'landline',
    whatsApp: 'whatsapp',
    email: 'email',
    linkFacebook: 'facebook',
    linkInstagram: 'instagram',
    linkLinkedin: 'linkedin',
    uf: 'state',
    cidade: 'city',
    rua: 'address',
    numeroEndereco: 'addressNumber',
    bairro: 'district',
    cep: 'zipCode',
    complemento: 'addressComplement',
    textoModal: 'modalText'
};

export const MAP_MENSAGEM: FieldMap = {
    nome: 'name',
    email: 'email',
    telefone: 'phone',
    assunto: 'subject',
    estilo: 'type',
    mensagem: 'text'
};
